import { Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';

// Import **solid** icons instead of outline
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthService } from '../../service/auth-service';
import { CartService } from '../../service/cart-service';
import { map } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-navbar',
  imports: [ RouterLink,FontAwesomeModule, RouterLinkActive ],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss'
})
export class Navbar implements OnInit{
  faShoppingBag = faShoppingBag;
  protected authService = inject(AuthService)
  protected cartService = inject(CartService)
  protected cartItem = 0;
  private snackBar = inject(MatSnackBar)

  ngOnInit(): void {
    this.cartService.cart$.subscribe(res=>{
      if(res!=null)
      this.cartItem=res.length as number
    })
  }

  logout(){
    this.authService.logout().subscribe((res)=>{
      this.snackBar.open("Logged out successfully!", 'Close', { duration: 5000 });
    }, (error)=>{
      this.snackBar.open("Logout failed!", 'Close', { duration: 5000 });
      console.error(error)
    })
  }
}
